import React, { useEffect, useState } from "react";
import { Navigate, useLocation, useNavigate } from "react-router";
import { Button, ButtonGroup } from "@progress/kendo-react-buttons";
import { Dialog,DialogActionsBar } from "@progress/kendo-react-dialogs";
import { Input } from "@progress/kendo-react-inputs";
import { TextBox } from "@progress/kendo-react-inputs";

import "../../../../components/dialog/notification.css";

export const ContactSearch= (props) => {
    let {search} = useLocation();
    const query = new URLSearchParams(search);
    const [searchName,setSearchTitle] = useState("");
    const [searchNumber,setSearchNumber] = useState("");
    const [searchDepartment,setSearchDepartment] = useState("");
    useEffect(() => {
        if(query.get("name")){
            setSearchTitle(query.get("name"));            
        }
        if(query.get("contact_number")){
            setSearchNumber(query.get("contact_number"));
        }
        if(query.get("department")){
            setSearchDepartment(query.get("department"));
        }
    },[])
    const onhandleSearch = ()=>{
        const data = {
            name : searchName? searchName: "",
            contact_number : searchNumber? searchNumber: "",
            department : searchDepartment? searchDepartment: "",
        }
        console.log("Contact Search",data);
        props.onSearchcallback(data);
    }
    const handleSearchName = (e)=>{
        setSearchTitle(e.target.value);
    }
    const handleSearchCreator = (e)=>
        setSearchNumber(e.target.value);
    const handleSearchDepartment = (e)=>
        setSearchDepartment(e.target.value);
    return (
        <>
        <Dialog
            className="search-notification"
            title={" "}
            // width={500}
            height={"100%"}
            onClose={()=> props.setShowSearchDialog(false)}
            >
            <div className="search-body">
                <div className="noti-dialog-title dialog-row">Search</div>
                <div className="dialog-row">
                    <span className="search-row-title">By Contact Name</span>
                    <TextBox 
                        className="search-input" 
                        value={searchName}
                        onChange={handleSearchName}
                        suffix={()=>(
                            <Button className="clear-button-dialog" onClick={()=> setSearchTitle("")}>X</Button>
                        )}
                    />
                </div>
                <div className="dialog-row" style={{height:"80%"}}>
                    <span className="search-row-title">By Phone Number</span>
                    <TextBox 
                        className="search-input" 
                        onChange={handleSearchCreator} 
                        value={searchNumber}
                        suffix={()=>(
                            <Button className="clear-button-dialog" onClick={()=> setSearchNumber("")}>X</Button>
                        )}/>
                </div>
                <div className="dialog-row" style={{height:"80%"}}>
                    <span className="search-row-title">By Department</span>
                    <TextBox 
                        className="search-input" 
                        onChange={handleSearchDepartment} 
                        value={searchDepartment}
                        suffix={()=>(
                            <Button className="clear-button-dialog" onClick={()=> setSearchDepartment("")}>X</Button>
                        )}/>
                </div>
            </div>
            <DialogActionsBar>
                <Button className="search-button cancel-btn" onClick={()=> props.setShowSearchDialog(false)}>Cancel</Button>
                <Button className="search-button search-btn" onClick={onhandleSearch}>Submit</Button>
            </DialogActionsBar>
        </Dialog>        
        </>
        
    );
  };